import React, { useState, useEffect, useRef } from 'react';
import { IconButton } from '@mui/material';
import MapView from '@arcgis/core/views/MapView';
import { useApp } from '../../../../hooks';
import mapLayersAppliedEvent from '../../../../services/fetch/user-events/map-layers-applied-event';
import LayerPicker from '../../../../layer-picker';

interface Props {
  id: string,
  editing: boolean,
  view?: MapView,
}

type FetchMapView = () => MapView | undefined;

const layerPickers: Array<HTMLDivElement | null> = [];

export const LayerPickerWidget = ({ id, editing, view }: Props) => {
  const [showLayerPicker, setShowLayerPicker] = useState(false);
  const app = useApp();
  const layerPickerEditorRef = useRef<HTMLDivElement | null>(null);
  const fetchMapView: FetchMapView = () => view;

  const handlePickerClose = async () => {
    await mapLayersAppliedEvent(
      'ESRI',
      app.layerSettings.activeBasemap.id,
      app.layerSettings.activeOverlays,
    );

    setShowLayerPicker(false);
  };

  useEffect(() => {
    if (layerPickerEditorRef.current) {
      layerPickers.push(layerPickerEditorRef.current);

      if (layerPickers.length > 1) {
        layerPickers.shift()?.remove();
      }
    }
  });

  return (
    <div ref={layerPickerEditorRef}>
      <IconButton
        className="esri-component esri-widget--button esri-widget"
        sx={{ borderRadius: 0 }}
        onClick={() => setShowLayerPicker(true)}
        title="Basemap & layers"
        id={`layer-picker-${id}`}
      >
        <span data-testid="esri-icon-layers" className="esri-icon esri-icon-layers" />
      </IconButton>
      <LayerPicker
        esriEnabled
        view={fetchMapView}
        editing={editing}
        onClose={handlePickerClose}
        show={showLayerPicker}
      />
    </div>
  );
};

export default LayerPickerWidget;
